module.exports = __webpack_public_path__ + "media/images/emblems/Lengwil-blazon-d54f06860acb2ad63f780765441c3d47.svg";